// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer global de l'application. Surface en gris Centralis (#484848), identique a
   la navbar connectee et a la sidebar. Palette fermee : titres en blanc gras,
   texte clair #cdd0d0/#9aa0a6, survol blanc. */
.app-footer {
  background: #484848;
  color: #cdd0d0;
  width: 100%;
}

.app-footer-inner {
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  justify-content: space-between;
  padding: 4rem 6rem 2.5rem;
}

.app-footer-brand {
  max-width: 32rem;
  min-width: 22rem;
}

.app-footer-logo {
  height: 26px;
  width: auto;
  display: block;
  margin-bottom: 1.2rem;
}

.app-footer-tagline {
  font-size: 1.4rem;
  line-height: 1.5;
  color: #9aa0a6;
  margin: 0;
}

.app-footer-cols {
  display: flex;
  flex-wrap: wrap;
  gap: 3.5rem;
}

.app-footer-col {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  min-width: 14rem;
}

.app-footer-col-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.4rem;
}

.app-footer-link {
  font-size: 1.2rem;
  color: #cdd0d0;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  width: fit-content;
  transition: color 0.15s ease;
}

.app-footer-link:hover {
  color: #ffffff;
}

.app-footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding: 1.4rem 6rem;
  font-size: 1.1rem;
  color: #9aa0a6;
  text-align: center;
}

@media (max-width: 900px) {
  .app-footer-inner {
    padding: 3rem 2rem 2rem;
    gap: 2.5rem;
  }
  .app-footer-cols {
    gap: 2.5rem;
  }
  .app-footer-bottom {
    padding: 1.4rem 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/Footer/Footer.css"],"names":[],"mappings":"AAAA;;+CAE+C;AAC/C;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* Footer global de l'application. Surface en gris Centralis (#484848), identique a\n   la navbar connectee et a la sidebar. Palette fermee : titres en blanc gras,\n   texte clair #cdd0d0/#9aa0a6, survol blanc. */\n.app-footer {\n  background: #484848;\n  color: #cdd0d0;\n  width: 100%;\n}\n\n.app-footer-inner {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3rem;\n  justify-content: space-between;\n  padding: 4rem 6rem 2.5rem;\n}\n\n.app-footer-brand {\n  max-width: 32rem;\n  min-width: 22rem;\n}\n\n.app-footer-logo {\n  height: 26px;\n  width: auto;\n  display: block;\n  margin-bottom: 1.2rem;\n}\n\n.app-footer-tagline {\n  font-size: 1.4rem;\n  line-height: 1.5;\n  color: #9aa0a6;\n  margin: 0;\n}\n\n.app-footer-cols {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3.5rem;\n}\n\n.app-footer-col {\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n  min-width: 14rem;\n}\n\n.app-footer-col-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 0.4rem;\n}\n\n.app-footer-link {\n  font-size: 1.2rem;\n  color: #cdd0d0;\n  text-decoration: none;\n  background: none;\n  border: none;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n  font-family: inherit;\n  width: fit-content;\n  transition: color 0.15s ease;\n}\n\n.app-footer-link:hover {\n  color: #ffffff;\n}\n\n.app-footer-bottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n  padding: 1.4rem 6rem;\n  font-size: 1.1rem;\n  color: #9aa0a6;\n  text-align: center;\n}\n\n@media (max-width: 900px) {\n  .app-footer-inner {\n    padding: 3rem 2rem 2rem;\n    gap: 2.5rem;\n  }\n  .app-footer-cols {\n    gap: 2.5rem;\n  }\n  .app-footer-bottom {\n    padding: 1.4rem 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
